import { adminApiFetch } from './apiService';

export const salesChannelService = {
  // 列表（用於下拉選單）
  list: async (params = {}) => {
    // 過濾掉 undefined 或 null 的參數
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v != null)
    );
    const queryParams = new URLSearchParams(cleanParams);

    const response = await adminApiFetch(`sales_channels?${queryParams.toString()}`);
    return response.json();
  },

  // 列表（用於表格）
  getRecords: async (params) => {
    const response = await adminApiFetch('sales_channels/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await adminApiFetch('sales_channels/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 取得單筆
  get: async (id) => {
    const response = await adminApiFetch(`sales_channels/${id}`);
    return response.json();
  },

  // 更新
  // payload 為 buildPayload 組出的完整 body（含 sales_channel 與 top-level
  // sales_channel_rules / sales_channel_shipping_rules），不可只送 sales_channel，
  // 否則後端讀不到 top-level 規則參數、規則不會被儲存。
  update: async (id, payload) => {
    const response = await adminApiFetch(`sales_channels/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
    return response.json();
  },

  // 新增
  // payload 同上：送完整 body，保留 top-level 規則參數。
  create: async (payload) => {
    const response = await adminApiFetch('sales_channels', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    return response.json();
  }
};
